import { render, staticRenderFns } from "./AddVisitDetails.vue?vue&type=template&id=0165a358&scoped=true"
import script from "./AddVisitDetails.vue?vue&type=script&lang=js"
export * from "./AddVisitDetails.vue?vue&type=script&lang=js"
import style0 from "./AddVisitDetails.vue?vue&type=style&index=0&id=0165a358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165a358",
  null
  
)

export default component.exports